const actionlocation = 'footer-module';

export const MODULE_VIEW_EVENT_OPTIONS = {
  actionlocation
};
